import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Script timing data we want to track

export var LongAnimationFrameMeasurer = /*#__PURE__*/function () {
  function LongAnimationFrameMeasurer(options) {
    var _this = this;
    _classCallCheck(this, LongAnimationFrameMeasurer);
    _defineProperty(this, "longestScriptTimings", []);
    _defineProperty(this, "minimumIndex", -1);
    _defineProperty(this, "minimumDuration", Infinity);
    this.options = options;
    this.paused = options.insmSession.insm.runningHeavyTasks.size !== 0;
    if (PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
      this.observer = new PerformanceObserver(function (list) {
        if (!_this.paused) {
          // only handle batches when tracking is not paused
          _this.handleBatch(list.getEntries());
        }
      });
      this.observer.observe({
        type: 'long-animation-frame',
        buffered: options.initial
      });
    }
  }
  return _createClass(LongAnimationFrameMeasurer, [{
    key: "handleBatch",
    value: function handleBatch(batch) {
      for (var batchIndex = 0; batchIndex < batch.length; batchIndex++) {
        var animationFrame = batch[batchIndex];

        // Only process frames that exceed the reporting threshold
        if (animationFrame.duration < this.options.reportingThreshold) {
          continue;
        }

        // Process all scripts in this long animation frame
        if (animationFrame.scripts && animationFrame.scripts.length > 0) {
          var _iterator = _createForOfIteratorHelper(animationFrame.scripts),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var script = _step.value;
              this.processScript(script, animationFrame);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }
  }, {
    key: "createScriptTiming",
    value: function createScriptTiming(script, animationFrame) {
      return {
        duration: script.duration,
        forcedStyleAndLayoutDuration: script.forcedStyleAndLayoutDuration,
        invoker: script.invoker,
        invokerType: script.invokerType,
        sourceCharPosition: script.sourceCharPosition,
        sourceFunctionName: script.sourceFunctionName,
        sourceURL: script.sourceURL,
        features: Array.from(this.options.insmSession.runningFeatures),
        afDuration: animationFrame.duration
      };
    }
  }, {
    key: "processScript",
    value: function processScript(script, animationFrame) {
      var scriptDuration = script.duration;
      var len = this.longestScriptTimings.length;

      // Not yet at capacity: append and update min tracking incrementally
      if (len < this.options.limit) {
        var _scriptTiming = this.createScriptTiming(script, animationFrame);
        this.longestScriptTimings[len] = _scriptTiming;
        if (len === 0 || scriptDuration < this.minimumDuration) {
          this.minimumDuration = scriptDuration;
          this.minimumIndex = len;
        }
        return;
      }

      // At capacity: only do work if we beat the current min
      if (scriptDuration <= this.minimumDuration) {
        return;
      }
      var scriptTiming = this.createScriptTiming(script, animationFrame);

      // Replace the current min
      this.longestScriptTimings[this.minimumIndex] = scriptTiming;

      // Find new minimum
      var newMinimumIndex = 0;
      var newMinimumDuration = this.longestScriptTimings[0].duration;
      for (var i = 1; i < this.options.limit; i++) {
        if (this.longestScriptTimings[i].duration < newMinimumDuration) {
          newMinimumIndex = i;
          newMinimumDuration = this.longestScriptTimings[i].duration;
        }
      }

      // Update the min tracking
      this.minimumIndex = newMinimumIndex;
      this.minimumDuration = newMinimumDuration;
    }

    /**
     * Pauses tracking
     */
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }

    /**
     * Resumes tracking
     */
  }, {
    key: "resume",
    value: function resume() {
      this.paused = false;
    }

    /**
     * Returns the current tracked longest script timings sorted by duration
     */
  }, {
    key: "current",
    get: function get() {
      var copy = this.longestScriptTimings.slice();
      copy.sort(function (a, b) {
        return b.duration - a.duration;
      });
      return copy;
    }

    /**
     * Cleans up the performance tracking (tracking cannot be resumed following this).
     */
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this$observer;
      (_this$observer = this.observer) === null || _this$observer === void 0 || _this$observer.disconnect();
    }
  }]);
}();

// Based on https://github.com/GoogleChrome/web-vitals/blob/1b872cf5f2159e8ace0e98d55d8eb54fb09adfbe/src/types.ts#L129
// exported for use in test file

// Based on https://github.com/GoogleChrome/web-vitals/blob/1b872cf5f2159e8ace0e98d55d8eb54fb09adfbe/src/types.ts#L129